import React, {useEffect, useRef, useState, useContext} from 'react';
import {withRouter} from 'react-router-dom';

import {AppContext} from '../../AppModule/Context';

import FormComponentV2 from '../common/genericComponents/redesign/formComponentV2/formComponentV2';
import LoaderComponent from '../common/genericComponents/redesign/loaderComponent/loaderComponent';
import SeparatorComponent from '../common/genericComponents/separatorComponent/separatorComponent';
import Spinner from '../common/genericComponents/spinner';
import ThreeDRow from '../expertDashboardModule/expertSettingsComponent/components/expertRightSettingsComponent/dashboardModuleComponents/widgetSetUpAndInstallationComponent/setUpAndInstallationComponent/components/threedComponents/threeDRow';
import TitleComponentV2 from '../common/genericComponents/redesign/titleComponentV2/titleComponentV2';

import indexDbService from '../../services/indexDbService';
import ThreeDService from '../../services/restServices/threedService';
import utilsService from '../../services/utilsService';

import VIDABOO_CONSTANTS from '../../config/consts';

import './threedMentorSelect.css';

const ThreedMentorSelect = (props) => {
  const [threedArr, setThreedArr] = useState([]);
  const [selected3DFile, setSelected3DFile] = useState({});
  const [isAllFilesFetched, setIsAllFilesFetched] = useState(false);
  const [isFileLoading, setIsFileLoading] = useState(false);
  const [dbInitialization, setDbInitialization] = useState(false);
  const [showUploadUI, setShowUploadUI] = useState(false);
  const [urlOfFile, setUrlOfFile] = useState(null);
  const fileTimeoutId = useRef(null);

  const context = useContext(AppContext);

  useEffect(() => {
    indexDbService.initialize((result) => {
      if (result) {
        setDbInitialization(true);
      }
    });
    return () => {
      if (fileTimeoutId.current) {
        window.clearTimeout(fileTimeoutId.current);
      }
    };
  }, []);

  useEffect(() => {
    const showUploadUI =
      dbInitialization &&
      isAllFilesFetched &&
      utilsService.isEmptyHash(selected3DFile);
    setShowUploadUI(showUploadUI);
  }, [dbInitialization, isAllFilesFetched, selected3DFile]);

  useEffect(() => {
    setIsAllFilesFetched(false);
    getAll3dFiles(props.currentUser.userId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.currentUser.userId]);

  useEffect(() => {
    const urlOfFile =
      VIDABOO_CONSTANTS.MEDIA_MESSAGES_STORAGE +
      `${selected3DFile.tempThumbnailUrl}`;
    setUrlOfFile(urlOfFile);
  }, [selected3DFile.tempThumbnailUrl]);

  const onClick3DFile = (threeDFile) => {
    setIsFileLoading(true);
    if (fileTimeoutId.current) {
      window.clearTimeout(fileTimeoutId.current);
    }
    fileTimeoutId.current = setTimeout(() => {
      setSelected3DFile(threeDFile);
      setIsFileLoading(false);
    }, 200);
  };

  const getAll3dFiles = async () => {
    const personal3dResponse =
      await ThreeDService.getThreedFilesByObjectTypeAndObjectId(
        'PERSONAL',
        props.currentUser.userId,
      );
    let arr = [];
    if (personal3dResponse?.status === 200) {
      arr = [...personal3dResponse.threedFileDtos];
    }
    let account3dResponse = [];
    // if part of account then (accountDto is active )then fetch by account as well.
    if (context.getAccountDto() && context.getAccountDto().isActive) {
      account3dResponse =
        await ThreeDService.getThreedFilesByObjectTypeAndObjectId(
          'ACCOUNT',
          context.getAccountDto().accountId,
        );
    }
    if (account3dResponse?.threedFileDtos?.length > 0) {
      arr = [...arr, ...account3dResponse.threedFileDtos];
    }
    const selected3DFile = arr.find((threed) => threed.savingState === 'READY');
    if (selected3DFile) {
      setSelected3DFile(selected3DFile);
    }

    setThreedArr(arr);
    setIsAllFilesFetched(true);
  };

  const handleUploadFile = () => {
    const ROUTES = utilsService.getRoutesEnumByImpersonationMode(
      context.isImpersonatedModeActive,
    );
    props.history.push(ROUTES.EXPERT_SETTINGS, {
      navUrl: 'widgetSetup/setUpInstallation/threedSense',
    });
  };

  const handlePresentFile = () => {
    props.presentFile(selected3DFile);
  };

  return (
    <div
      className={`et-threed-mentor-select-container ${!dbInitialization || !isAllFilesFetched || showUploadUI ? 'et-threed-mentor-select-small-container' : ''}`}>
      <FormComponentV2
        isRightBtnDisabled={false}
        showRightBtn={dbInitialization && isAllFilesFetched}
        formTitle={
          !dbInitialization || !isAllFilesFetched
            ? 'Initializing the 3D Engine'
            : showUploadUI
              ? 'Upload a 3D file'
              : 'Select 3D file'
        }
        leftBtnTxt="Close"
        rightBtnTxt={showUploadUI ? 'Upload' : 'Present'}
        onLeftBtnClicked={props.handleClose}
        onRightBtnClicked={showUploadUI ? handleUploadFile : handlePresentFile}>
        {dbInitialization && isAllFilesFetched ? (
          showUploadUI ? (
            <>
              <SeparatorComponent />
              <TitleComponentV2
                titleTxt={
                  'Please upload a 3D file in Setup & installation -> 3D Sense to use this feature.'
                }
              />
              <SeparatorComponent />
            </>
          ) : (
            <div className="et-tms-threed-rows-data-preview-wrap">
              <div className="et-tms-threed-rows-data-wrap">
                {threedArr.map((threed) => {
                  return (
                    threed.savingState === 'READY' && (
                      <ThreeDRow
                        key={threed.threedFileId}
                        threeDFile={threed}
                        onClick3DFile={() => onClick3DFile(threed)}
                        selectedFile={selected3DFile}
                        type={'chat'}
                      />
                    )
                  );
                })}
              </div>
              <div className="et-tms-threed-vertical-separator" />
              <div className="et-tms-threed-preview-wrap">
                <div className="et-tms-threed-preview-img">
                  {!isFileLoading &&
                  props.startThreedWithPeer &&
                  Object.keys(selected3DFile).length > 0 ? (
                    <img src={urlOfFile} alt="3Dimage" />
                  ) : (
                    <Spinner />
                  )}
                </div>
              </div>
            </div>
          )
        ) : (
          <div className="et-tms-db-loader-wrap">
            <LoaderComponent />
          </div>
        )}
      </FormComponentV2>
    </div>
  );
};

export default withRouter(ThreedMentorSelect);
